export const createSportsbookHistoryPageToken = () => ({
  cursor: null,
  bufferedRows: [],
  canFetch: true,
  snapshotAt: '',
});

export const createSportsbookHistoryCursorState = () => ({
  currentPageToken: createSportsbookHistoryPageToken(),
  visitedPageTokens: [],
});

export const createSportsbookHistoryCursorContext = (queryKey) => ({
  queryKey,
  state: createSportsbookHistoryCursorState(),
});

export const resolveSportsbookHistoryCursorState = (context, queryKey) => (
  context.queryKey === queryKey ? context.state : createSportsbookHistoryCursorState()
);

export const advanceSportsbookHistoryCursor = (state, nextPageToken) => {
  if (!nextPageToken) return state;
  return {
    currentPageToken: nextPageToken,
    visitedPageTokens: [...state.visitedPageTokens, state.currentPageToken],
  };
};

export const retreatSportsbookHistoryCursor = (state) => {
  if (state.visitedPageTokens.length === 0) return state;
  const visitedPageTokens = state.visitedPageTokens.slice(0, -1);
  return {
    currentPageToken: state.visitedPageTokens[state.visitedPageTokens.length - 1],
    visitedPageTokens,
  };
};

export const selectSportsbookHistoryCursorPage = (state, pageNumber, nextPageToken = null) => {
  const currentPageNumber = state.visitedPageTokens.length + 1;
  if (!Number.isInteger(pageNumber) || pageNumber < 1 || pageNumber === currentPageNumber) return state;
  if (pageNumber === currentPageNumber + 1) return advanceSportsbookHistoryCursor(state, nextPageToken);
  if (pageNumber > state.visitedPageTokens.length) return state;
  const knownPageTokens = [...state.visitedPageTokens, state.currentPageToken];
  return {
    currentPageToken: knownPageTokens[pageNumber - 1],
    visitedPageTokens: knownPageTokens.slice(0, pageNumber - 1),
  };
};

export const sportsbookHistoryCursorPageNumber = (state) => state.visitedPageTokens.length + 1;
